module.exports = __webpack_public_path__ + "img/Classroom-text.d8558d68.jpg";